import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3cc72f8d"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=3cc72f8d&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=3cc72f8d&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports